<template>
  <div class="root">
    <div class="cases" v-if="caseShow">
      <div class="type">{{`${$t('content.case')}${ifShowS?'s':''} (${caseFilter.length})`}}</div>
      <div class="case-space">
        <div class="case-wrapper" v-for="(item,index) in caseFilter" :key="item['caseName']">
          <case-card
            :item="item"
            :index="index"
            :caseShowActions="caseShowActions"
            @showActions="showOptions"
            @hideActions="hideOptions"
          ></case-card>
        </div>
      </div>
    </div>
    <div class="items" v-if="itemShow">
      <div class="type">{{`${$t(itemTitle)}${ifShowS?'s':''} (${itemFilter.length})`}}</div>
      <div class="item-space">
        <div
          class="item-wrapper"
          :class="{editMode:editMode}"
          v-for="(item,index) in itemFilter"
          :key="item.o_id"
        >
          <item-card
            :item="item"
            :index="index"
            :itemShowActions="itemShowActions"
            :nowHover="nowHover"
            @hidePopover="hidePopover"
            @showPopover="showPopover"
            @showActions="showOptions"
            @hideActions="hideOptions"
          ></item-card>
        </div>
      </div>
    </div>
    <div class="blank" v-if="!itemShow&&!caseShow">No File</div>
  </div>
</template>

<script>
import itemCard from "@/components/itemCard";
import caseCard from "@/components/caseCard";
import popover from "@/components/popover";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    popover,
    caseCard,
    itemCard
  },
  props: {
    cases: {
      type: Array,
      default() {
        return [];
      }
    },
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      caseShowActions: -1,
      itemShowActions: -1,
      nowHover: -1
    };
  },
  computed: {
    ...mapState(["editMode", "beSelected", "allCases", "keyWord"]),
    caseShow() {
      return this.caseFilter.length !== 0;
    },
    itemShow() {
      return this.itemFilter.length !== 0;
    },
    itemTitle() {
      switch (this.type) {
        case "all":
          return "content.item";
        case "doc":
          return "content.document";
        case "graph":
          return "content.graph";
        case "inCase":
          return "content.item";
        case "tagSearch":
          return "content.document";
        case "search":
          return "content.item";
      }
    },
    //Fitering cases when search by keyword
    caseFilter() {
      let cases = this.cases;
      if (this.type == "search") {
        cases = cases.filter(v => {
          let reg = new RegExp(this.keyWord, "i");
          let flag = reg.test(v.caseName);
          return flag;
        });
      }
      return cases;
    },
    //Filtering items when search by keyword
    itemFilter() {
      let items = this.items;
      if (this.type == "search") {
        items = items.filter(v => {
          let reg = new RegExp(this.keyWord, "i");
          let match = ["name", "companyName_cn", "companyName_en", "stockCode"];
          let flag = match.some(cur_match => {
            if (v[cur_match]) {
              return reg.test(v[cur_match]);
            }
            return false;
          });

          return flag;
        });
      }
      return items;
    },
    // If show 's' after 'File' and 'Case'
    ifShowS() {
      return this.$i18n.locale == "en";
    }
  },
  methods: {
    ...mapMutations(["select"]),
    /**
     * @param {String} type -case|item
     * @param {Number} index
     */
    showOptions(type, index) {
      if (type == "case") {
        this.caseShowActions = index;
      } else {
        this.itemShowActions = index;
      }
      document.addEventListener("click", this.hideOptions, false);
    },
    hideOptions() {
      this.$nextTick(() => {
        this.caseShowActions = -1;
        this.itemShowActions = -1;
        document.removeEventListener("click", this.hideOptions);
      });
    },
    showPopover(index) {
      this.nowHover = index;
    },
    hidePopover() {
      this.nowHover = -1;
    }
  }
};
</script>

<style lang="scss" scoped>
.cases {
  margin-top: 20px;
  border-top: 1px solid $border-color;
  position: relative;
  .type {
    color: $dark-purple;
    padding-right: 15px;
    font-size: $font-base-size;
    font-weight: 500;
    line-height: 21px;
    position: absolute;
    display: inline-block;
    background-color: $back-color;
    top: -10px;
  }
  .case-space {
    @include flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 21px;
    padding: 0 15px;
    .case-wrapper {
      flex: 0 1 25%;
    }
  }
}
.items {
  @extend .cases;
  .item-space {
    @include flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 21px;
    padding: 0 15px;
    .item-wrapper {
      flex: 0 1 25%;

      &.editMode {
        .item-normal.selected {
          border-color: $light-purple;
          .checkbox {
            background-color: $light-purple;
            &::after {
              content: "\e99e";
              font-family: "gekko_fonts" !important;
              font-size: 18px;
              left: 6px;
              top: 6px;
              color: $base-color;
              position: absolute;
            }
          }
        }
        .item-mask {
          @include flex;
          position: absolute;
          left: -2px;
          bottom: -2px;
          width: 230px;
          height: 198px;
          background: rgba(105, 115, 204, 0.4);
          border-radius: 0px 0px 4px 4px;
          .checkbox {
            width: 30px;
            height: 30px;
            border: 1px solid $light-purple;
            border-radius: 4px;
            cursor: pointer;
            background-color: $base-color;
            transition: all 300ms;
            position: relative;
          }
        }
      }
      .item-normal,
      .item-tag-note {
        position: relative;
        padding-top: 10px;
        margin: 12px 10px;
        width: 230px;
        height: 300px;
        border: 2px solid transparent;
        background: $base-color;
        box-shadow: 2px 3px 10px -4px rgba(13, 36, 60, 1);
        border-radius: 0px 4px 4px 4px;
        transition: all 500ms;
        cursor: pointer;
        & > .find-case {
          position: absolute;
          background-color: $light-purple;
          width: 30px;
          height: 30px;
          border-top-left-radius: 4px;
          border-bottom-right-radius: 4px;
          right: -2px;
          bottom: -2px;
          &:hover {
            background-color: $font-base-color;
          }
        }
        div.option {
          display: none;
        }
        &.active,
        &.showActions {
          box-shadow: 2px 3px 30px -10px rgba(13, 36, 60, 1);

          & > div.option {
            position: absolute;
            display: block;
            font-size: 26px;
            color: $light-purple;
            right: 8px;
            top: 8px;
            z-index: 100;
          }
        }
        .item-title {
          padding: 0 10px;
          height: 25px;
          padding-bottom: 5px;
          position: relative;
          & > span.icon {
            display: inline-block;
            font-size: 20px;
            width: 20px;
            height: 20px;
            color: #156ec9;
            &.graph {
              color: #fd9620;
            }
          }
          & > span:last-child {
            display: inline-block;
            color: $dark-purple;
            font-size: 16px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 160px;
          }
          &::after {
            @include after;
            height: 1px;
            width: 190px;
            background-color: $border-color;
            bottom: -1px;
            left: 10px;
          }
        }
        .item-thumbnail {
          height: 200px;
        }
        .item-info {
          @include flex;
          padding: 4px 14px;
          justify-content: flex-start;
          flex-direction: column;
          align-items: flex-start;
          color: $dark-purple;
          font-size: 13px;
          height: 67px;
          & > span {
            line-height: 20px;
          }
          & > span.last-saved {
            color: #b8bbc2;
            font-size: 12px;
            margin-top: auto;
          }
        }
      }
      .item-tag-note {
        .item-title {
          @include flex;
          position: absolute;
          justify-content: flex-start;
          padding: 0;
          width: 230px;
          height: 36px;
          left: -2px;
          top: -2px;
          background-color: $light-purple;
          color: $base-color;
          font-size: 16px;
          border-top-right-radius: 4px;
          & > span.icon {
            text-align: center;
            color: $base-color;
            width: 30px;
          }
          & > .return {
            margin-left: auto;
          }
        }
        .item-body {
          margin-top: 26px;
          height: 249px;
          overflow-y: scroll;
          .tag-space {
            @include flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 5px 15px;
          }
          .note-space {
            .note {
              position: relative;
              list-style: none;
              line-height: 20px;
              padding: 0 10px 0 18px;

              &::before {
                @include after;
                width: 8px;
                height: 8px;
                top: 6px;
                left: 5px;
                background-color: #2c92ff;
                border-radius: 50%;
              }
              .text {
                display: inline-block;
                color: $dark-purple;
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
}
.blank {
  @include flex;
  color: #e1e3e7;
  font-size: 30px;
  font-weight: 600;
  width: 100%;
  height: 100%;
}
.root {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/gridView.vue